export const iconFontAwesomeDesignCircleHalfStroke = (
	<i className="fa-solid fa-circle-half-stroke"></i>
);
